import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {WarningModalService} from "../warning-modal/warning-modal.service";
import {IsDirty} from "./is-dirty.interface";
import { ClearDraftService } from "../../shared/clear-draft.service";
import { PermissionsService } from '../permissions/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard  {

  constructor(
    private modal: WarningModalService,
    private clearDraftService: ClearDraftService,
    private permissions: PermissionsService
  ) {
  }

  canDeactivate(
    component: IsDirty,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // If component is dirty, warn user
    if (component.isDirty()) {
      // @ts-ignore
      if (route['routeConfig']['path'] === 'request') {
        let title = $localize`Leave this page?`;
        let message = $localize`All request information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
        let cancelButton = $localize`Stay on page`;
        let agreeButton = $localize`Leave this page`;
        let modal = this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton);
        try {
            modal.subscribe(($leavePage) => {
              if ($leavePage) {
                this.clearDraftService.callComponentMethod();
              }
            });
          } catch (error) { }

          return modal;
      }

      let sourcePath = route?.routeConfig?.path;
      if (nextState['url'] == '/no-access' && (sourcePath === 'surveys/create' || sourcePath === 'surveys/edit')) {
        return true;
      }

      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton);
    } else {
      return true;
    }
  }
}
